import { useCallback, useContext } from "react"
import ContextualMenu from "components/contextual-menu"
import { SelectedPortfolio } from "helpers/types/instruments/selected"
import { LOADING } from "helpers/data-statuses"
import { usePortfolioMenuItems } from "../hooks/use-resource-menu-items"
import { IDashboardContextValue } from "../context/types"
import { DashboardContext } from "../context/dashboard"

function onSuccess() {
  window.location.reload()
}

export function ResourceMenuSwitcher() {
  const { instrument, setInstrument } = useContext<IDashboardContextValue>(DashboardContext)
  if (instrument?.type === "PORTFOLIO" && instrument?.experimentId === undefined) {
    return <PortfolioMenu instrument={instrument} setInstrument={setInstrument} />
  }
  return null
}

function PortfolioMenu({ instrument, setInstrument }: PortfolioMenuProps) {
  const onDelete = useCallback(() => setInstrument(null), [setInstrument])

  const [resourceMenuItems, resourceMenuItemsStatus] = usePortfolioMenuItems(instrument, onSuccess, onDelete)
  if (resourceMenuItems) {
    return <ContextualMenu className="dashboard-contextual-menu" items={resourceMenuItems} disabled={resourceMenuItemsStatus === LOADING} />
  }
  return null
}

interface PortfolioMenuProps {
  instrument: SelectedPortfolio
  setInstrument: IDashboardContextValue["setInstrument"]
}
